import {
    ClickElement,
    ClickText,
    EventCategory,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

function trackTabSwitched(label: string, caption: string): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'TabClick',
            label,
            eventData: {
                eventName: GA4EventName.ClickTab,
                feature_category: GA4FeatureCategory.ProductDetailInformation,
                click_element: label,
                click_text: caption,
            },
        });
    }, 0);
}

function trackMapClicked(): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: EventCategory.ProductDetail,
            action: 'Map',
            label: 'CloseUp',
            eventData: {
                eventName: GA4EventName.OpenMap,
                feature_category: GA4FeatureCategory.ProductDetailInformation,
                click_element: ClickElement.MapInDescription,
                click_text: ClickText.MapViewBig,
            },
        });
    }, 0);
}

function trackExpandCountryLocationsClicked(
    countryCode: string | undefined,
    country: string,
): void {
    if (countryCode) {
        setTimeout(() => {
            trackAnalyticsEvent({
                category: 'ProductDetail',
                action: 'Map',
                label: `Expand_${country}`,
            });
        }, 0);
    }
}

export { trackExpandCountryLocationsClicked, trackMapClicked, trackTabSwitched };
